// @ts-strict-ignore
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CustomValidators } from '@shared/custom-validators';

@Component({
  standalone: false,
  selector: 'edit-project-article-number',
  templateUrl: './edit-project-article-number.component.html',
})
export class EditProjectArticleNumberComponent implements OnInit, OnDestroy {

  public articleNumber: string;
  public isAutomaticGenerationAvailable: boolean = false;
  public isAutomaticGenerationSelected: boolean = false;

  public maxArticleNumberChars: number = 80;
  public form: FormGroup;
  @Output() public finish = new EventEmitter<{ articleNumber: string, isAutomaticGenerationSelected: boolean }>();
  public readonly articleNumberTextInputName: string = 'articleNumberTextInput';

  constructor(private bsModalRef: BsModalRef, private formBuilder: FormBuilder) {
  }

  public ngOnInit(): void {
    const formData: any = {};
    formData[this.articleNumberTextInputName] = new FormControl(this.articleNumber, CustomValidators.validArticleNoLong);
    this.form = this.formBuilder.group(formData);

    this.form.valueChanges.subscribe(inputValue =>  {
      if (inputValue[this.articleNumberTextInputName].length > 0) {
        // order in which inputValue is modified is important, because regexes are configured that way
        let modifiedInputValue = inputValue[this.articleNumberTextInputName].replace(/[-/]$/g, '');
        modifiedInputValue = this.addBackslashes(modifiedInputValue);
        modifiedInputValue = this.addDashes(modifiedInputValue);

        this.form.patchValue({ 'articleNumberTextInput' : modifiedInputValue}, {emitEvent: false});
      }
    });
  }

  private addBackslashes(input: string): string {
    const valueWithBackslash =  input.split('/').join('');
    return valueWithBackslash.match(new RegExp('.{1,9}', 'g')).join('/');
  }

  private addDashes(input: string): string {
    const valueWithDashes = input.split('-').join('');
    const regex = /^[0-9A-Z]{4}|[0-9A-Z]{4}\/[0-9A-Z]{1,4}|[0-9A-Z]{1,4}$/g;
    return valueWithDashes.match(regex).join('-');
  }

  public ngOnDestroy(): void {
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public save(): void {
    this.close();
    this.finish.emit({
      articleNumber: this.form.controls.articleNumberTextInput.value.trim(),
      isAutomaticGenerationSelected: this.isAutomaticGenerationSelected
    });
  }
}
